module.exports = __webpack_public_path__ + "media/11_4.7aa25dba.wav";